/** Fixed Gói 1 EXEC capability catalog — mirrors BE MesCapabilities. */
export const MesCapabilities = {
  Preop: "preop",
  Recv: "recv",
  Sort: "sort",
  SortQc: "sort_qc",
  Weigh: "weigh",
  Cook: "cook",
  Usage: "usage",
  Pack: "pack",
  FgGr: "fg_gr",
  Qc: "qc",
  Generic: "generic",
  Metal: "metal",
  Pasteur: "pasteur",
  Cap: "cap",
} as const;

export type MesCapability =
  (typeof MesCapabilities)[keyof typeof MesCapabilities];

export const MES_CAPABILITY_LABELS: Record<MesCapability, string> = {
  preop: "Chuẩn bị",
  recv: "Nhận nguyên liệu",
  sort: "Phân loại",
  sort_qc: "Phân loại QC",
  weigh: "Cân",
  cook: "Nấu",
  usage: "Xuất dùng",
  pack: "Đóng gói",
  fg_gr: "Nhập thành phẩm",
  qc: "Kiểm tra chất lượng",
  generic: "Chung",
  metal: "Dò kim loại",
  pasteur: "Thanh trùng",
  cap: "Đóng nắp",
};

export function mesCapabilityLabel(code?: string | null): string {
  const key = code?.trim().toLowerCase() as MesCapability | undefined;
  if (!key) return "—";
  return MES_CAPABILITY_LABELS[key] ?? code ?? "—";
}

const CODE_MAP: Record<string, MesCapability> = {
  "OP-RECV-LINE": MesCapabilities.Recv,
  "OP-SORT": MesCapabilities.Sort,
  "OP-SORT-QC": MesCapabilities.SortQc,
  "OP-ISSUE-WEIGH": MesCapabilities.Weigh,
  "OP-COOK": MesCapabilities.Cook,
  "OP-USAGE": MesCapabilities.Usage,
  "OP-MD": MesCapabilities.Metal,
  "OP-CAP": MesCapabilities.Cap,
  "OP-PASTEUR": MesCapabilities.Pasteur,
  "OP-METAL": MesCapabilities.Metal,
  "OP-PAIL-FILL": MesCapabilities.Pack,
  "OP-PAIL-FG": MesCapabilities.Pack,
  "OP-JAR-FILL": MesCapabilities.Pack,
  "OP-FG-GR": MesCapabilities.FgGr,
};

export function resolveMesCapability(
  capability?: string | null,
  opType?: string | null,
  operationCode?: string | null,
): MesCapability {
  if (capability?.trim()) {
    return capability.trim().toLowerCase() as MesCapability;
  }
  const code = operationCode?.trim().toUpperCase() ?? "";
  if (code && CODE_MAP[code]) return CODE_MAP[code];
  if (code.startsWith("OP-PREOP")) return MesCapabilities.Preop;
  switch ((opType ?? "").trim().toLowerCase()) {
    case "preop":
      return MesCapabilities.Preop;
    case "qc":
      return MesCapabilities.Qc;
    case "pack":
      return MesCapabilities.Pack;
    case "wh":
      return MesCapabilities.FgGr;
    default:
      return MesCapabilities.Generic;
  }
}
